import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8pygbzi7: FaireBrandEntity = {
  token: "b_8pygbzi7",
  type: "brand",
  name: "FABLERUNE",
  avatarUrl:
    "https://cdn.faire.com/fastly/042641a3e0068d9cd46f9fd1a97ea185b82b7b7e8587ce59a07980679962ba1a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1ee7984dabed41bdde00d5bf5462ab1a25ac5c4574c309e8b2768e9fae41506c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/042641a3e0068d9cd46f9fd1a97ea185b82b7b7e8587ce59a07980679962ba1a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1ee7984dabed41bdde00d5bf5462ab1a25ac5c4574c309e8b2768e9fae41506c.jpeg",
  location: "Los Osos, CA, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 19,
  isInsider: true,
  description:
    "SELFCARE AS CEREMONY\n\nWe believe in the power of ritual — the quiet moments that ground us, the ceremonies that connect us, and the sacred practices that bring us back to ourselves. Rooted in ancestral wisdom and guided by intuition, we create offerings that honor the body, mind, and spirit — transforming the everyday into something ethereal and intentional.\n\nWhether you are lighting a candle to calm your space, anointing your skin with nourishing oils, or creating a cleansing ritual to restore balance, we help guide you through moments of stillness, warmth, and renewal.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:05.056Z",
    importedBy: "entity-db-cli",
  },
};
